exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imgSizeMedium[data-v-66752205]{width:64px;height:64px;overflow:hidden;border-radius:50%;display:inline-block}.imgSizeSmall[data-v-66752205]{width:48px;height:48px;overflow:hidden;border-radius:50%;display:inline-block}.imgSizeLarge[data-v-66752205]{width:96px;height:96px;overflow:hidden;border-radius:50%;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66752205","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/HeadImg/index.vue
// module id = 710
// module chunks = 0